import * as React from "react";
import { Icon } from "../../Icon/icon";
import { PaginationPreviousProps } from "./WizardPagination.types";

export class Previous extends React.Component<PaginationPreviousProps> {
  navigatePrevious = (
    currentStepIndex: number,
    isDisabled: boolean,
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    this.props.changeStepCallback(
      this.props.paginationSteps[currentStepIndex - 1].stepId,
      e
    );
  };

  public render() {
    let anchorClassName = "pagination__link";
    let buttonClassName = "button button--white-arrow-left";
    let currentStepIndex = this.props.currentStepIndex;
    let isDisabled = currentStepIndex === 0;
    if (this.props.showButtons) {
      isDisabled = currentStepIndex === 0 || currentStepIndex === 3;
    }
    if (isDisabled) anchorClassName += " pagination__link--disabled";
    let JSX = null;
    if (this.props.showButtons) {
      if (!isDisabled) {
        JSX = (
          <a
            onClick={(e) => this.navigatePrevious(currentStepIndex, false, e)}
            href="#"
            className={buttonClassName}
          >
            {this.props.previousLabel}
          </a>
        );
      }
    } else {
      if (!isDisabled) {
        JSX = (
          <a
            onClick={(e) =>
              this.navigatePrevious(currentStepIndex, isDisabled, e)
            }
            href="#"
            className={anchorClassName}
          >
            <Icon iconType="fontawesome/chevron-left" />
            <span className="pagination__verbose">
              {this.props.previousLabel}
            </span>
          </a>
        );
      } else {
        JSX = (
          <span aria-disabled="true" className={anchorClassName}>
            <Icon iconType="fontawesome/chevron-left" />
            <span className="pagination__verbose">
              {this.props.previousLabel}
            </span>
          </span>
        );
      }
    }

    return JSX;
  }
}
